module.exports = __webpack_public_path__ + "static/media/nadya.bc427e71.png";